export const SHOW_STATICS_RIGHTS = [1];
export const SHOW_EXPORT_BUTTON = [1];

